define([
	"dojo/_base/declare",
	"csi/action/NewController",
	"csi/xml"
], function(declare,NewController,xml) {

	var PROPAGATE = "Propagate3DMaterial";
	var PROPAGATE_FIELD = "3DPropagate3DMaterials";

	return declare(NewController, {
		onCreatePopup: function(/*csi.view.Widget*/view) {
			// summary: set default name for ColorSpec
			this.inherited(arguments);

			var parentNode = this.getParent();
			var colorSpecUrl = (parentNode && parentNode.$Type == "MaterialPlanPlacement") ?
					parentNode.MPPColorSpec : parentNode.MPCColorSpec;

			if (xml.isValidURL(colorSpecUrl)) {
				view.addFixedValue("ColorSpecification", colorSpecUrl);
			}
		},

		/**
		 * Call server Java operation to create Color Material and propagate 3D Material if needed
		 * @param {array} val
		 */
		toWriterRequest: function() {
			var formData = this.getFormData();

			// Create Color Material using server operation
			var call = this.inherited(arguments);
			return call.addParameter(PROPAGATE, xml.ATTR_BOOLEAN, formData.getFieldValue(PROPAGATE_FIELD, true));
		}
	});
});